import React from "react";

function ArrowDown({ width = 24, height = 25, fill = "#7C6060" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_40_22414)">
        <path
          d="M16.59 8.58997L12 13.17L7.41 8.58997L6 9.99997L12 16L18 9.99997L16.59 8.58997Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default ArrowDown;
